var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialDataIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 187,
    viewBox: "0 0 237 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236.333,
    height: 187,
    rx: 16,
    fill: "#EFEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 188.333,
    height: 139,
    rx: 16.3778,
    fill: "#DED6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 57.6587L133.261 57.6593L133.261 93.4001L114.794 93.4001",
    stroke: "#6D42FF",
    strokeOpacity: 0.6,
    strokeWidth: 1.48889,
    strokeLinecap: "round",
    strokeDasharray: "2.98 2.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164 130.159L133.262 130.159L133.262 93.3994L114.795 93.3995",
    stroke: "#6D42FF",
    strokeOpacity: 0.6,
    strokeWidth: 1.48889,
    strokeLinecap: "round",
    strokeDasharray: "2.98 2.98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 93.398L133.261 93.3979L104.5 93.3976",
    stroke: "#6D42FF",
    strokeOpacity: 0.9,
    strokeWidth: 1.48889,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 45.1587,
    width: 28,
    height: 24,
    rx: 12,
    fill: "#6D42FF",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 81.1587,
    width: 28,
    height: 24,
    rx: 12,
    fill: "#5232BF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 57.1587,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#6D42FF",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 69.1587,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#7C55FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 117.159,
    width: 28,
    height: 24,
    rx: 12,
    fill: "#6D42FF",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialDataIntegration);
export default __webpack_public_path__ + "static/media/financial-data-integration.2a48cef0ad15be9ee13a7dc54bbd1fdb.svg";
export { ForwardRef as ReactComponent };